import {User} from 'src/openapi/models/User';
import {RootState} from 'src/store/store';

export const getUser = (state: RootState): User | null => state.user.data;
